import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      selected: []
    }
  },
  mutations: {
    setSelectedData (state, payload) {
      state.selected[payload.id] = payload.answer;
    }
  }
});

export default store;